import React from 'react';
import { Grid, Paper, Skeleton, Typography } from '@mui/material';
import { ANALYTICS_WINDOWS, AnalyticsWindow, TileCounts, plural } from '../model';

interface WindowTilesProps {
  // Undefined until the first summary arrives; every summary carries all three windows' counts.
  tiles?: Record<AnalyticsWindow, TileCounts>;
  selected: AnalyticsWindow;
  onSelect: (window: AnalyticsWindow) => void;
}

const WindowTiles: React.FC<WindowTilesProps> = ({ tiles, selected, onSelect }) => (
  <Grid container spacing={2}>
    {ANALYTICS_WINDOWS.map(({ key, label }) => {
      const isSelected = key === selected;
      const handleSelect = () => {
        if (!isSelected) onSelect(key);
      };
      const counts = tiles?.[key];

      return (
        <Grid item xs={12} sm={4} key={key}>
          <Paper
            role="button"
            tabIndex={0}
            aria-pressed={isSelected}
            onClick={handleSelect}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleSelect();
              }
            }}
            elevation={isSelected ? 2 : 1}
            sx={{
              p: 2,
              cursor: 'pointer',
              border: isSelected ? '2px solid' : '1px solid',
              borderColor: isSelected ? 'primary.main' : 'divider',
              outline: 'none',
              transition: 'box-shadow 150ms ease',
              '&:hover': { boxShadow: 3 },
              '&:focus-visible': { boxShadow: 4, borderColor: 'primary.main' },
            }}
          >
            <Typography variant="h6" sx={{ lineHeight: 1.2 }}>
              {label}
            </Typography>
            {counts ? (
              <>
                <Typography variant="h5" sx={{ mt: 1, lineHeight: 1.2 }}>
                  {plural(counts.active_users, 'active user')}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  {plural(counts.pages_opened, 'page opened', 'pages opened')}
                </Typography>
              </>
            ) : (
              <>
                <Skeleton sx={{ mt: 1 }} width={140} height={32} />
                <Skeleton width={80} height={16} />
              </>
            )}
          </Paper>
        </Grid>
      );
    })}
  </Grid>
);

export default WindowTiles;
